'use client';

import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import SwitcherArrow from '../svg/switcher-arrow';
import Globus from '../svg/globus';
import { usePathname, useRouter } from 'next/navigation';

const languages = [
  { code: 'sw', label: 'SW' },
  { code: 'en', label: 'EN' },
];

export default function LanguageSwitcher() {
  const router = useRouter();
  const pathname = usePathname();
  const [selectedLang, setSelectedLang] = useState(languages[0]);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const segments = pathname.split('/').filter(Boolean);
    const currentLang = languages.find(l => l.code === segments[0]) || languages[0];
    setSelectedLang(currentLang);
  }, [pathname]);

  const handleSelect = (langCode: string) => {
    const lang = languages.find((l) => l.code === langCode);
    if (!lang) return;

    // Получаем текущий язык из URL
    const segments = pathname.split('/').filter(Boolean);
    const currentLang = languages.find(l => l.code === segments[0]) || languages[0];
    
    // Если выбран тот же язык, просто закрываем меню
    if (currentLang.code === langCode) {
      setIsOpen(false);
      return;
    }

    setSelectedLang(lang);
    setIsOpen(false);
  
    const hasLangPrefix = languages.some((l) => l.code === segments[0]);
    const cleanPath = hasLangPrefix ? segments.slice(1).join('/') : segments.join('/');
  
    const newPath = langCode === 'sw'
      ? `/${cleanPath}` || '/'
      : `/${langCode}${cleanPath ? `/${cleanPath}` : ''}`;
  
    // Отправляем событие с информацией о текущем и новом языке
    window.dispatchEvent(new CustomEvent('languageChangeStart', {
      detail: {
        currentLang: currentLang.code,
        newLang: langCode
      }
    }));
    
    router.push(newPath);
    router.refresh();
  };

  return (
    <div
      className="relative inline-block text-left"
      onMouseEnter={() => setIsOpen(true)}
      onMouseLeave={() => setIsOpen(false)}
    >
      <div className="cursor-pointer py-[5px] transition flex items-center gap-[3.5px] text-[16px] font-bold text-violet-500">
        <Globus />
        {selectedLang.label}
        <SwitcherArrow />
      </div>

      {isOpen && (
        <motion.div
          initial={{ opacity: 0, y: -5 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -5 }}
          className="absolute left-0 top-[22px] mt-2 w-full bg-white rounded-2xl shadow-xl shadow-[0_2px_8px_0_#00000026] z-10 min-w-[75px] px-[8px]"
        >
          {languages.map((lang) => (
            <div
              key={lang.code}
              className={`py-[5px] cursor-pointer text-[16px] font-semibold text-violet-500 border-b-2 last:border-b-0 border-dotted ${
                lang.code === selectedLang.code ? 'font-bold' : ''
              }`}
              onClick={() => handleSelect(lang.code)}
            >
              {lang.label}
            </div>
          ))}
        </motion.div>
      )}
    </div>
  );
}